module.exports = __webpack_public_path__ + "33f1c1cd801d785dabbe6c77a45f21c3.svg";